import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ScoreSheet = () => {
    const navigate = useNavigate();
    const { compId } = useParams();
    const [scores, setScores] = useState([]);
    const [competition, setCompetition] = useState({});
    const [parameters, setParameters] = useState([]);

    const fetchCompetitionDetails = () => {
        Axios.get(
            `https://ashish.moodi.org/multicity/get_compi_details?id=${compId}`
        )
            .then((res) => setCompetition(res.data))
            .catch((err) => console.error(err));
    };

    const fetchCompiScores = () => {
        Axios.post(
            "https://ashish.moodi.org/multicity/get_mul_final_scores",
            {
                competition: compId,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => setScores(res.data))
            .catch((err) => console.error(err));
    };

    const fetchParameters = () => {
        Axios.get(
            `https://ashish.moodi.org/multicity/get_mul_parameters?id=${compId}`
        )
            .then((res) => setParameters(res.data))
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (localStorage.getItem("compiauthtoken")) {
            fetchCompiScores();
            fetchCompetitionDetails();
            fetchParameters();
        } else {
            navigate("/admin/login");
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div className="container-fluid overflow-auto">
            <div className="row my-3">
                <h2 className="text-center col-sm-6">
                    {competition.mcName} - Final Score Sheet
                </h2>
            </div>
            <table>
                <thead>
                    <tr>
                        <th className="p-3 text-center">Position</th>
                        <th className="p-3 text-center">Slot No</th>
                        <th className="p-3 text-center">MI NO</th>
                        <th className="p-3 text-center">Name</th>
                        <th className="p-3 text-center">College</th>

                        {parameters.map((parameter) => {
                            return (
                                <th className="p-3" key={parameter.mcpId}>
                                    {parameter.parameterName}
                                </th>
                            );
                        })}
                        <th className="p-3">Total Score</th>
                    </tr>
                </thead>
                <tbody>
                    {scores.map((score, index) => {
                        return (
                            <tr
                                key={score.MI_NO}
                                className="border border-warning"
                            >
                                <td className="text-center px-3">
                                    {index + 1}
                                </td>
                                <td className="px-3 text-center">
                                    Slot - {score.slotNumber}
                                </td>
                                <td className="px-3 text-center">
                                    {score.MI_NO}
                                </td>
                                <td className="px-3 text-center">
                                    {score.userName}
                                </td>
                                <td className="px-3 text-center">
                                    {score.collegeName}
                                </td>
                                {parameters.map((parameter) => {
                                    return (
                                        <td className="px-3 text-center">
                                            {score[parameter.parameterName]}
                                        </td>
                                    );
                                })}
                                <td className="px-3 text-center">
                                    {score.totalScore}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ScoreSheet;
